module.exports = __webpack_public_path__ + "static/media/logo_cebfiba_en_white.0eaedfc8.png";